export default "__VITE_ASSET__DksBc4A$__"